<template>
    <view-with-bar>
        <template slot="bar">
            <view-bar>
                <h1>Payment batches</h1>
                <view-bar-item route="/payment-factory/batches">Payment batches</view-bar-item>
                <view-bar-item route="/payment-factory/batch-templates">Batch templates</view-bar-item>
                <h1>Payments</h1>
                <view-bar-item route="/payment-factory/payments">Payments</view-bar-item>
            </view-bar>
        </template>
    </view-with-bar>
</template>

<script>
    import ViewWithBar from "../components/layout/ViewWithBar";
    import ViewBarItem from "../components/navigation/ViewBarItem";
    import ViewBar from "../components/navigation/ViewBar";
    export default {
        name: "PaymentFactoryView",
        components: {ViewBar, ViewBarItem, ViewWithBar}
    }
</script>

<style scoped>

</style>